import { MemberPublic } from "projects/mijn/src/app/member/models/member";
import {
  OrganizationPublic,
  OrganizationWithAddressesDto,
} from "../../organisation/models/organization";
import { StartSettingSmallOrgDto } from "../../organisation/models/startsetting";
import { SubscriptionDto } from "../../organisation/models/subscription";
import { User } from "../../users/models/user";

export class GlobalVariables {
  public static startSettings: StartSettingSmallOrgDto;
  public static organization: OrganizationPublic | OrganizationWithAddressesDto;
  public static subscription: SubscriptionDto;
  public static user: User;
  public static member: MemberPublic;
  public static imageUrl: string = "https://app.assistonline.eu";
  public static isWhiteLabelVsvw: boolean = false;
 

  set startSettings(data: StartSettingSmallOrgDto) {
    GlobalVariables.startSettings = data;
  }

  get startSettings(): StartSettingSmallOrgDto {
    return GlobalVariables.startSettings;
  }

  set organization(org: OrganizationPublic | OrganizationWithAddressesDto) {
    GlobalVariables.organization = org;
    
    
  }

  get organization(): OrganizationPublic | OrganizationWithAddressesDto {
    return GlobalVariables.organization;
  }

  set member(member: MemberPublic) {
    GlobalVariables.member = member;
  }

  get member(): MemberPublic {
    return GlobalVariables.member;
  }

 
}
